<template>
  <form @submit.prevent="submit">
    <base-modal target="investorRepaymentModal" :title="title">
      <base-error v-if="message">
        {{ message }}
      </base-error>
      <base-field label="Type" mandatory>
        <base-select v-model="payload.type" :options.sync="types" placeholder="type" />
      </base-field>
      <base-field addon-left-icon="pound-sign" label="Amount" mandatory>
        <base-input v-model="payload.amount" numeric placeholder="amount" />
      </base-field>
      <base-field label="Funding Round" mandatory>
        <base-select v-model="payload.funding" :model.sync="investment.rounds" placeholder="funding round" />
      </base-field>
      <template v-if="payload.funding">
        <base-field addon-left-icon="pound-sign" label="Credit">
          <base-input v-model="payload.credit" numeric placeholder="credit" />
        </base-field>
        <base-field addon-left-icon="pound-sign" label="Debit">
          <base-input v-model="payload.debit" numeric placeholder="debit" />
        </base-field>
        <base-field addon-left-icon="pound-sign" label="Capital">
          <base-input v-model="payload.capital" numeric placeholder="capital" />
        </base-field>
        <base-field addon-left-icon="pound-sign" label="Interest Due">
          <base-input v-model="payload.interestDue" numeric placeholder="interest due" />
        </base-field>
      </template>
      <base-checkbox v-model="payload.bypassPaymentProvider">
        Bypass payment provider (Lemonway)
      </base-checkbox>
      <template v-slot:footer>
        <base-button @click="$modal.close('#investorRepaymentModal')">
          Cancel
        </base-button>
        <base-button :disabled="!canSubmit()" :loading="pending" secondary submit>
          Pay
        </base-button>
      </template>
    </base-modal>
  </form>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'InvestorRepayment',

  props: {
    investment: {
      required: true,
      type: Object
    },
    user: {
      default: () => ({}),
      type: Object
    }
  },

  data: () => ({
    message: '',
    payload: {
      amount: '',
      bypassPaymentProvider: false,
      capital: '',
      credit: '',
      debit: '',
      funding: '',
      interestDue: '',
      type: ''
    },
    types: []
  }),

  computed: {
    title () {
      if (this.$_.has(this.user, 'profile')) {
        const { companyName, firstName, lastName, isCompany } = this.user.profile
        const name = isCompany ? companyName : `${firstName} ${lastName}`

        return `Repay Investor: ${name}`
      } else {
        return 'Repay Investor'
      }
    },

    ...mapState({
      paymentTypes: store => store.core.paymentTypes.entities,
      pending: store => store.core.investments.isPayInvestorPending
    })
  },

  created () {
    this.getPaymentTypes()
      .then(entities => {
        entities
          .filter(type => {
            return [
              'bonus',
              'capital-return',
              'cashback',
              'gift',
              'interest-accrued',
              'redemption'
            ].includes(type.key)
          })
          .forEach(type => {
            this.types.push({
              text: type.description,
              value: type.key
            })
          })
      })
  },

  mounted () {
    this.$modal.hidden('#investorRepaymentModal', () => {
      this.reset()
    })
  },

  methods: {
    canSubmit () {
      return this.payload.amount && this.payload.funding
    },

    reset () {
      this.message = ''
      this.payload = {
        amount: '',
        bypassPaymentProvider: false,
        capital: '',
        credit: '',
        debit: '',
        funding: '',
        interestDue: '',
        type: ''
      }
      this.types = []
    },

    submit () {
      const payload = {
        investment: this.investment._id,
        funding: this.payload.funding.name,
        user: this.user.email,
        type: this.payload.type,
        amount: this.payload.amount,
        credit: this.payload.credit,
        debit: this.payload.debit,
        capital: this.payload.capital,
        interestDue: this.payload.interestDue,
        bypassPaymentProvider: this.payload.bypassPaymentProvider
      }

      this.payInvestor(payload)
        .then(transaction => {
          if (transaction.status === 'SUCCESS') {
            this.$flash.success('Payment made successfully')
            this.$modal.close('#investorRepaymentModal')
          } else if (transaction.message) {
            this.message = transaction.message
          }
        })
    },

    ...mapActions({
      getPaymentTypes: 'core/payment-types/all',
      payInvestor: 'core/investments/pay-investor'
    })
  }
}
</script>
